export const robotta = require('./robotta.json');
export const kult = require('./kult.json');
export const alien = require('./alien.json');

const customDices = {
    robotta,
    kult,
    alien,
};

export default customDices;
